import WaitingForActionModalBody from "#/shared/components/modals/WaitingForActionModalBody"

export default function WaitingForStakingTransaction() {
  return <WaitingForActionModalBody title="Waiting for transaction..." />
}
